<template>
  <div class="flex flex-col gap-4">
    <template v-if="isUrnHandover">
      <template v-for="(formItem, index) in document.form" :key="index">
        <DynamicFormInput
          v-if="['receiver_type', 'person_type'].includes(formItem.name)"
          :defaultValue="formItem.value"
          :question="formItem"
          :questionIndex="index"
          :vertical_align="formItem.name !== 'receiver_type'"
          ajax-attribute-label="title"
          ajax-track-by="title"
          radioTrackBy="id"
          @questionValue="setQuestionValue"
        />
        <DynamicFormInput
          v-if="
            document.form[0]?.value === 2 &&
            [
              'receive_name',
              'receiver_family_link',
              'receiver_adresse',
              'receiver_phone'
            ].includes(formItem.name)
          "
          :defaultValue="formItem.value"
          :question="formItem"
          :questionIndex="index"
          ajax-attribute-label="title"
          ajax-track-by="title"
          radioTrackBy="id"
          @questionValue="setQuestionValue"
        />
        <BaseSelectSimpleAjax
          v-if="document.form[0]?.value === 1 && formItem.name === 'customer'"
          v-model="formItem.value"
          :label="formItem.question"
          :name="formItem.name"
          :url="formItem.url"
          :default-ajax="customerOption"
          attributeLabel="name"
          trackBy="id"
        />
      </template>
    </template>
    <template v-else>
      <DynamicFormInput
        v-for="(formItem, index) in document.form"
        :key="index"
        :defaultValue="formItem.value"
        :question="formItem"
        :questionIndex="index"
        ajax-attribute-label="title"
        ajax-track-by="title"
        radioTrackBy="id"
        @questionValue="setQuestionValue"
      />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

/**
 * The questions of a document with a form (`document.form`), answered in the
 * document store: the render page builds the PDF URL from them.
 */
export default {
  name: 'WorkDocumentForm',
  props: {
    document: { type: Object, required: true }
  },
  computed: {
    ...mapGetters({
      work: 'work/getWork',
      customer: 'customer/getSelectedCustomer'
    }),
    isUrnHandover() {
      return this.document.name === "Attestation de remise de l'urne"
    },
    customerOption() {
      if (!this.work) return null
      return { id: this.work.customer_id, name: this.customer?.name }
    }
  },
  watch: {
    // The urn handover's "customer" question starts on the work's customer.
    document: {
      immediate: true,
      handler(document) {
        if (!this.isUrnHandover || !this.work) return
        const index = document.form?.findIndex(
          (question) => question.name === 'customer'
        )
        const value = document.form?.[index]?.value
        if (index >= 0 && (value === undefined || value === '')) {
          this.alterQuestionValue({ index, value: this.work.customer_id })
        }
      }
    }
  },
  mounted() {
    if (this.work?.customer_id) {
      this.fetchCustomer({ id: this.work.customer_id })
    }
  },
  methods: {
    ...mapMutations({
      alterQuestionValue: 'document/alterDocumentQuestionValue'
    }),
    ...mapActions({ fetchCustomer: 'customer/fetchCustomerByID' }),
    setQuestionValue({ attribute, index, value }) {
      this.alterQuestionValue({ index, value, attribute })
    }
  }
}
</script>
